import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/auth';

const API = import.meta.env.VITE_API_BASE_URL || '';

export default function LoginPage() {
  const navigate = useNavigate();
  const { signIn, error } = useAuthStore();
  const [mode, setMode] = useState<'login' | 'signup'>('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setMsg(null);
    try {
      if (mode === 'signup') {
        const r = await fetch(`${API}/auth/signup`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, password }) });
        if (!r.ok) {
          const e2 = await r.json().catch(() => ({}));
          throw new Error(e2.message || 'Signup failed');
        }
        setMsg('Account created. An admin must verify your email before you can sign in (SES is sandboxed in dev).');
        setMode('login');
        return;
      }
      await signIn(email, password);
      navigate('/apps', { replace: true });
    } catch (err: any) {
      setMsg(err.message || 'Failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900 px-4">
      <div className="w-full max-w-sm bg-white rounded-xl p-8 shadow-lg">
        <h1 className="text-xl font-bold text-gray-900 mb-1">Developer Portal</h1>
        <p className="text-sm text-gray-500 mb-6">{mode === 'login' ? 'Sign in to manage your apps & keys' : 'Create a developer account'}</p>
        <form onSubmit={submit} className="space-y-4">
          <input type="email" required placeholder="you@company.com" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-gray-300 rounded-md px-3 py-2" />
          <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-gray-300 rounded-md px-3 py-2" />
          <button disabled={busy} className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 disabled:opacity-50">
            {busy ? '…' : mode === 'login' ? 'Sign in' : 'Sign up'}
          </button>
        </form>
        {(msg || error) && <p className="mt-3 text-sm text-gray-600">{msg || error}</p>}
        <button onClick={() => setMode(mode === 'login' ? 'signup' : 'login')} className="mt-4 text-sm text-blue-600">
          {mode === 'login' ? "Need an account? Sign up" : 'Have an account? Sign in'}
        </button>
      </div>
    </div>
  );
}
